module.exports = "../images/cabin-6-person-1@2x.jpg?v=1598e43";